import React, { useState } from "react";
import contactimg from "../../assets/images/contactus/contact1.webp";
import contactft from "../../assets/images/contactus/contact2.webp";
import { useParams } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import axios from "axios";
import Success from "../../common/Success";
import Animation from "../../common/Animation";
import contact_us from "../../assets/images/contactus/contact_us.gif"
import moment from "moment";
const ContactContent = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [open, setOpen] = useState(false);
  const [successModal, setsuccessModal] = useState(false);
  const [checked, setChecked] = useState(false);
  const initialform = {
    Name: "",
    Email: "",
    Number: "",
    Company: "",
    Location: "",
    Service: "",
    Message: "",
  };
  const [isformdata, setformdata] = useState(initialform);
  const handleformdata = (e) => {
    const { name, value } = e.target;
    setformdata((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  console.log("formData", isformdata)
  const handleFocus = () => {
    setIsExpanded(true);
  };

  const handleToggleCollapse = () => {
    setIsExpanded(false);
  };

  const [error, seterror] = useState({});
  const phoneValidation = (phone) => {
    const regex =
      /^([+]?[\s0-9]{1,16})?(\d{3}|[(]?[0-9]{1,16}[)])?([-]?[\s]?[0-9]{1,16})+$/;

    if (!phone || !regex.test(phone)) return false;

    const digitsOnly = phone.replace(/[+\s()-]/g, "");
    if (digitsOnly.length < 7 || digitsOnly.length > 16) return false;
    if (/^(\d)\1+$/.test(digitsOnly)) return false;

    return true;
  };
  const validate = () => {
    const newErrors = {};
    if (!isformdata.Name) newErrors.Name = "Please fillout the field";
    if (!isformdata.Email || !/\S+@\S+\.\S+/.test(isformdata.Email))
      newErrors.Email = "Invalid email address";
    if (!isformdata.Location) newErrors.Location = "Please fillout the field";
    if (!isformdata.Company) newErrors.Company = "Please fillout the field";
    if (!isformdata.Number) {
      newErrors.Number = "Please fillout the field";
    } else if (!phoneValidation(isformdata.Number)) {
      newErrors.Number = "Invalid phone number";
    }
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (validationErrors && Object.keys(validationErrors).length > 0) {
      seterror(validationErrors);
      return;
    }
    const updatedFormData = {
      ...isformdata,
      "Submitted Date": moment(new Date()).format("DD/MMM/yyyy hh:mm:ss"),
      Service: selectedServices,
    };
    const formDataObj = new FormData();
    for (const key in updatedFormData) {
      formDataObj.append(key, updatedFormData[key]);
    }
    console.log(
      "form submitted successfully",
      Array.from(formDataObj.entries())
    );
    seterror({});
    setformdata(initialform);
    setChecked(false)
    setSelectedServices([]);
    setsuccessModal(true);
    axios
      .post(
        "https://script.google.com/macros/s/AKfycbzq4m4Ul7BPrlcBIKwc6XOn1cysgBdvHeHeUatnHLG01SCZWe8gIJUzLUWLzYLy0JdS4Q/exec",
        formDataObj
      )
      .then((response) => {
        console.log("Response:", response.data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const services = [
    { id: "whatsapp-marketing", label: "WhatsApp Services", color: "#25D366" },
    { id: "sms-marketing", label: "SMS Services", color: "#FF5733" },
    { id: "linkedin-ads", label: "LinkedIn Ads", color: "#0077B5" },
    {
      id: "facebook-instagram-ads",
      label: "Facebook & Instagram Ads",
      color: "#4267B2",
    },
    { id: "twitter-ads", label: "SEO", color: "#1DA1F2" },
    { id: "ppc-campaign", label: "PPC Campaign", color: "#FF9900" },
    { id: "google-ads", label: "Google Ads", color: "#4285F4" },
  ];
  const [selectedServices, setSelectedServices] = useState([]);

  const toggleService = (serviceId) => {
    setSelectedServices((prevSelected) =>
      prevSelected.includes(serviceId)
        ? prevSelected.filter((id) => id !== serviceId)
        : [...prevSelected, serviceId]
    );
  };

  return (
    <div className="margin-topall">
      <section className="overflow-hidden">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <AnimatePresence mode="wait">
                {isExpanded ? (
                  <motion.div
                    key="collapse-icon"
                    initial={{ opacity: 0, x: 50 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: 50 }}
                    transition={{ duration: 0.4 }}
                    onClick={handleToggleCollapse}
                    style={{
                      cursor: "pointer",
                      textAlign: "left",
                      marginTop: "30px",
                    }}
                  >
                    <i className="fa-solid fa-arrow-left-long"></i>
                  </motion.div>
                ) : (
                  <motion.h1
                    key="heading"
                    className="contacthead mt-5"
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.4 }}
                  >
                    Let's Talk!
                  </motion.h1>
                )}
              </AnimatePresence>

              <form onSubmit={handleSubmit}>
                <div className="namepara py-2 flex flex-col">
                  <label htmlFor="name" className='py-3 flex flex-col namepara"'>
                    Hi! I am
                    <input
                      value={isformdata.Name}
                      onChange={handleformdata}
                      onFocus={handleFocus}
                      name="Name"
                      type="text"
                      placeholder="e.g. John Doe"
                      className="field"
                    />
                    {error.Name && (
                      <div className="mt-1 error">{error.Name}</div>
                    )}
                  </label>

                  <label htmlFor="email" className="py-3 flex flex-col">
                    Reach me at
                    <input
                      value={isformdata.Email}
                      onChange={handleformdata}
                      onFocus={handleFocus}
                      name="Email"
                      type="email"
                      placeholder="e.g. hello@gmail.com"
                      className="field"
                    />
                    {error.Email && (
                      <div className="mt-1 error">{error.Email}</div>
                    )}
                  </label>
                </div>
                <AnimatePresence initial={false}>
                  {isExpanded && (
                    <motion.div
                      key="expanded-section"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.5, ease: "easeInOut" }}
                      style={{ overflow: "hidden" }}
                    >
                      <div
                        className={`namepara expandable-form ${isExpanded ? "expanded" : ""
                          }`}
                      >
                        <label htmlFor="mobile" className="py-3 flex flex-col">
                          Mobile No.
                          <span className="numcolor">+91</span>
                          <input
                            value={isformdata.Number}
                            onChange={handleformdata}
                            name="Number"
                            type="tel"
                            placeholder="9696969696"
                            className="field"
                          />
                          {error.Number && (
                            <div className="mt-1 error">{error.Number}</div>
                          )}
                        </label>

                        <label htmlFor="company" className="py-3 flex flex-col">
                          Company Name
                          <input
                            value={isformdata.Company}
                            onChange={handleformdata}
                            name="Company"
                            type="text"
                            placeholder="e.g. sms zoo zoo"
                            className="field"
                          />
                          {error.Company && (
                            <div className="mt-1 error">{error.Company}</div>
                          )}
                        </label>

                        <label
                          htmlFor="location"
                          className="py-3 flex flex-col"
                        >
                          Location
                          <input
                            value={isformdata.Location}
                            onChange={handleformdata}
                            name="Location"
                            type="text"
                            placeholder="e.g. Chennai"
                            className="field"
                          />
                          {error.Location && (
                            <div className="mt-1 error">{error.Location}</div>
                          )}
                        </label>
                        <div>
                          <div>
                            <label
                              htmlFor="services"
                              className="py-3 flex flex-col"
                            >
                              Select Services
                            </label>
                            <div className="row px-2">
                              {services.map((service) => (
                                <div key={service.id} className="col-md-4 mb-4">
                                  <button
                                    type="button"
                                    className={`btn w-100 h-100 fw-bold ${selectedServices.includes(service.id)
                                      ? "btn-dark"
                                      : "btn-outline-dark"
                                      }`}
                                    onClick={() => toggleService(service.id)}
                                  >
                                    {service.label}
                                  </button>
                                </div>
                              ))}
                            </div>
                            <label htmlFor="message">Tell Us More</label>
                            <textarea
                              id="message"
                              name="Message"
                              rows={2}
                              className="fieldtext py-2"
                              value={isformdata.Message}
                              onChange={handleformdata}
                            ></textarea>
                            <div className="d-flex flex-row gap-2 align-items-center">
                              <input
                                name="terms"
                                type="checkbox"
                                checked={checked}
                                onChange={(e) => setChecked(e.target.checked)}
                                required
                              />
                              <p className="terms_checkbox">I have signed up to receive promotional, transactional, and notification messages via SMS, email, and WhatsApp</p>.
                            </div>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
                <div className="mt-4">
                  <button
                    type="submit"
                    onClick={() => setOpen(true)}
                    className={`btn save-btn d-flex align-items-center gap-2 ${isExpanded ? "bottom" : "top"
                      }`}
                  >
                    Save <i class="fa-solid fa-arrow-right-long"></i>
                  </button>
                </div>
              </form>
            </div>

            <div className="col-md-6">
              {/* <Animation /> */}
              <img src={contact_us} className="paddingcontact" alt="Contact" />
            </div>
          </div>
        </div>
      </section>
      <section className="pb-5 py-5  justify-content-between overflow-hidden">
        <div className="container">
          <div className="row gap-4">
            <div className="col-md-3">
              <img src={contactft} className="contactft " alt="contact" />
            </div>
            <div className="col-md-4"
              data-aos="fade-right" data-aos-delay="300"
            >
              <div className="contactborder contactfont">
                <h1>Chennai</h1>
                <p>
                  152B, 2 Floor, Panner Nagar
                  <br /> Main Road, Mogappair East, <br />
                  Chennai – 37.
                </p>
              </div>
            </div>
            <div className="col-md-4"
              data-aos="fade-left" data-aos-delay="300"
            >
              <div className="contactfont">
                <h1>Contact</h1>
                <div className="d-flex gap-2">
                  <i class="fa-solid fa-envelope mt-2"></i>
                  <div className="fontct">info.smszoozoo@gmail.com</div>
                </div>
                <div className="d-flex gap-2">
                  <i class="fa-solid fa-phone mt-2"></i>
                  <div className="fontct">
                    sales - 9047745477
                    <br />
                    support - 8012917912
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Success
        open={successModal}
        setOpen={() => {
          setsuccessModal(false);
        }}
      />
    </div>
  );
};

export default ContactContent;
